"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trainingRoutes = void 0;
exports.trainingRoutes = [
    {
        name: 'trainer.index',
        path: ['/jobs', '/jobs/q/:q'],
        method: 'GET'
    },
    {
        name: 'trainer.delete',
        path: ['/jobs/:id'],
        method: 'DELETE'
    },
    {
        name: 'trainer.start',
        path: '/start',
        method: 'POST'
    },
    {
        name: 'trainer.progress',
        path: '/progress/:modelId',
        method: 'GET'
    },
    {
        name: 'trainer.results',
        path: '/results/:modelId',
        method: 'GET'
    },
    {
        name: 'trainer.monitor',
        path: '/monitor/:jobId',
        method: 'POST'
    },
    {
        name: 'trainer.pdf.extract',
        path: '/pdf/extract',
        method: 'POST'
    },
    {
        name: 'trainer.pdf.generate',
        path: '/pdf/generate',
        method: 'POST'
    },
    {
        name: 'trainer.chapter.generate',
        path: '/chapter/generate',
        method: 'POST'
    },
    {
        name: 'trainer.jobDone',
        path: '/job-done',
        method: 'POST'
    },
    {
        name: 'trainer.models.list',
        path: '/models',
        method: 'GET'
    }
];
